import React from "react";
import { Badge, Flex } from "@chakra-ui/react";
import { STATUS_LABELS, STATUS_SCHEME, DEFAULT_STATUS_SCHEME } from "./contactCardsManageConstants";

/**
 * Renders the main status badge + supplementary deletion badges for a contact card.
 * The contact_card object's deleted_at and artist_deleted_at fields drive whether
 * the dashed "supprimé par" badges appear (each side has its own soft-delete timeline).
 * @param {Object} props
 * @param {Object} props.card - Contact card object
 * @param {boolean} [props.compact] - When true, hides deletion sub-badges (for tight rows)
 * @returns {React.ReactElement}
 */
function ContactCardStatusChip({ card, compact }) {
  const scheme = STATUS_SCHEME[card?.status] || DEFAULT_STATUS_SCHEME;
  const label = STATUS_LABELS[card?.status] || card?.status || "—";
  const deletedByClient = Boolean(card?.deleted_at);
  const deletedByArtist = Boolean(card?.artist_deleted_at);
  return (
    <Flex align="center" gap="6px" wrap="wrap">
      <Badge colorScheme={scheme} variant="subtle" borderRadius="6px" fontSize="0.7rem" px="8px" py="2px">{label}</Badge>
      {!compact && deletedByClient && <Badge colorScheme="red" variant="outline" borderRadius="6px" fontSize="0.6rem">Supprimé client</Badge>}
      {!compact && deletedByArtist && <Badge colorScheme="red" variant="outline" borderRadius="6px" fontSize="0.6rem">Supprimé artiste</Badge>}
    </Flex>
  );
}

export default ContactCardStatusChip;
